"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationSettings = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var pages_common_1 = require("@qwilr/pages-common");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./NavigationSettings.css"));
var NavigationStore_1 = __importDefault(require("./NavigationStore"));
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
exports.NavigationSettings = (0, mobx_react_1.observer)(function (_a) {
    var className = _a.className;
    var navigationStore = (0, inversify_react_1.useInjection)(NavigationStore_1.default);
    var brandStore = (0, inversify_react_1.useInjection)("brandStore");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var navigationContext = (0, pages_common_1.useNavigationContext)();
    var _b = __read((0, react_1.useState)(false), 2), showActions = _b[0], setShowActions = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), settingsOpen = _c[0], setSettingsOpen = _c[1];
    var optOutSpringboard = usingFeature(FeatureFlag_1.default.OptOutSpringboardEngagementMenu);
    (0, react_1.useEffect)(function () {
        var handleMouseMove = function (event) {
            if (event.clientY < 240 && event.clientX > window.innerWidth / 2) {
                setShowActions(true);
            }
            else {
                setShowActions(false);
            }
        };
        document.addEventListener("mousemove", handleMouseMove);
        return function () {
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, styles.actions({ show: showActions, open: settingsOpen })) },
        navigationContext.showNavWhileEditing && (react_1.default.createElement(kaleidoscope_1.Popover, { caret: true, padding: "none", isOpen: settingsOpen, className: styles.popover, onChange: function (isOpen) {
                setSettingsOpen(isOpen);
            }, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps),
                react_1.default.createElement(icons_1.Edit, null),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Configure nav"))); } },
            react_1.default.createElement("div", { className: styles.panelWrapper },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Layout", options: [
                        { label: "Top", value: "top" },
                        { label: "Left", value: "left" },
                        { label: "Floating", value: "floating" },
                    ], selectedValue: navigationStore.layout, onClickHandler: function (layout) {
                        navigationStore.layout = layout;
                    } }),
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                    react_1.default.createElement(kaleidoscope_1.Label, { size: "s" }, "Background"),
                    react_1.default.createElement(ColorPalette_1.default, { onColorChange: function (color) {
                            return (navigationStore.backgroundColor = { abs: color.value, themeIndex: color.themeIndex });
                        }, presetColors: brandStore.colorsWithThemeIndex, selectedColor: (0, GetBlockStyle_1.sanitizeColor)((0, GetBlockStyle_1.convertColorObjToColor)(navigationStore.backgroundColor), brandStore.colorsWithThemeIndex), theme: "light", type: "content" })),
                !optOutSpringboard && (react_1.default.createElement("div", { className: styles.explainerWrapper },
                    react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Springboard menu", value: navigationStore.springboardMenuEnabled, onChange: function (newValue) {
                            navigationStore.springboardMenuEnabled = newValue;
                        } }),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                        "Springboard allows your clients to stay engaged with Qwilr pages.",
                        " ",
                        react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/793-what-is-springboard" }, "Learn more")))),
                react_1.default.createElement("div", { className: styles.explainerWrapper },
                    react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show contact details", value: navigationStore.showContactDetails, onChange: function (newValue) {
                            navigationStore.showContactDetails = newValue;
                        } }),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" },
                        "Display the page owner's contact details in the blocks nav menu",
                        !optOutSpringboard && " and Springboard menu")),
                react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Blocks nav menu", value: navigationStore.showDrawer, onChange: function (newValue) {
                        navigationStore.showDrawer = newValue;
                    } }),
                react_1.default.createElement("div", { className: styles.explainerWrapper },
                    react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show quote total", value: navigationStore.showQuoteTotal, onChange: function (newValue) {
                            navigationStore.showQuoteTotal = newValue;
                        } }),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Display the total selected amount for all quote blocks on the page")),
                react_1.default.createElement("div", { className: styles.explainerWrapper },
                    react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Show Accept Button", value: navigationStore.showAccept, onChange: function (newValue) {
                            navigationStore.showAccept = newValue;
                        } }),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "Display the accept button to help guide readers of the page to the accept block"))))),
        react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: function () { return navigationContext.setShowNavWhileEditing(!navigationContext.showNavWhileEditing); } },
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, navigationContext.showNavWhileEditing ? "Hide nav while editing" : "Show nav while editing"))));
});
